import React from 'react';
import PropTypes from 'prop-types';
import './item.scss';

const item = (props) => {
  const { title, value, unit, id, description, isActive, callback, disabled } = props;
  let className = 'Item';
  if (isActive && !disabled)
    className += ' active';

  if (disabled)
    className += ' disabled';

  className += ' ' + id;

  return (
    <div
      className={ className }
      onClick={ () => callback(value) }
      data-value={value}
      data-key={id}
    >
      <span className={'title'}>
        {title}
        {
          unit.length > 0 &&
          <small> { ' ' } { unit } </small>
        }

      </span>
      {
        description &&
        <span className={'description'}>
          {React.isValidElement(description) ? description : `${description}`}
        </span>
      }
    </div>
  );
};


item.defaultProps = {
  id: '',
  unit: '',
  isActive: false,
  disabled: false,
  callback: () => {},
};

item.propTypes = {
  title: PropTypes.any.isRequired,
  id: PropTypes.string,
  unit: PropTypes.string,
  description: PropTypes.node,
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  callback: PropTypes.func
};

export default item;

